import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import useReveal from "@/hooks/useReveal";

export default function Layout({ children }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  useReveal();

  return (
    <div className="relative min-h-screen bg-[#000000] text-white overflow-x-clip">
      <Navbar />
      <main className="pt-16 md:pt-20">{children}</main>
      <Footer />
    </div>
  );
}
